module.exports = "<div class=\"loading\" [class.visible-loading]=\"preloaderVisible\"><img src=\"{{ src }}\"></div>"


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/preloader/preloader.component.html
// module id = ../../../../../angular/app/components/defaults/preloader/preloader.component.html
// module chunks = 1